
import * as React from 'react';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { ActionSelector, ISelectedActionProps, evaluateAction } from '../../withAction/WithAction';
import { sharedFieldClickActionControl } from '../../../controls/sharedFieldClickActionControl';

export interface IItemManageAccessActionProps {
  itemKey: string | undefined;
}

/**
 * Action which provides the ability to manage user access to a shared item.
 */
export const ItemManageAccessAction: React.ComponentType<IItemManageAccessActionProps> =
  connectToItemCache((
    itemCache: IItemCache,
    props: IItemManageAccessActionProps
  ): ISelectedActionProps => {
    const {
      itemKey
    } = props;

    const controlHandler = itemCache.demandItemFacet(sharedFieldClickActionControl, props.itemKey);

    const {
      onClickAction: manageAccessAction
    } = sharedFieldClickActionControl.evaluate(controlHandler)(itemCache, {
      itemKey
    });

    return {
      action: evaluateAction(itemCache, manageAccessAction)
    };
  })(ActionSelector);
